import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import useTableFilter from '../../../components/TableFilter/useTableFilter';
import { schoolListTableColumns } from './SchoolListTableColumn';
import { clearState, comparePhotoModule, getDDOs } from '../ComparePhotoDucks';
import { Table } from './CreateOrderModalStyles';

const SchoolListTable = ({
  selectedDdo,
  index,
  ddos,
  getDDOs,
  loading,
  clearState,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const { nextPage } = useTableFilter(filter => getDDOs(filter), undefined);

  return (
    <Table
      rowBgColor={row =>
        row.original.id === selectedDdo.id ? 'rgba(125,125,125,0.2)' : undefined
      }
      loading={loading}
      columns={schoolListTableColumns(t, i18n.language)}
      data={ddos.content}
      totalElements={ddos.totalElements}
      onClickLoadMore={() => nextPage()}
      {...rest}
    />
  );
};

export default connect(
  state => ({
    loading: state[comparePhotoModule].loading,
    ddos: state[comparePhotoModule].ddos
  }),
  {
    getDDOs,
    clearState
  }
)(SchoolListTable);
